import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { forkJoin, of, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { Dealer, DEALERS, DealerCurrent, DealerStatus, DEALER_STATUSES } from '../data/dealer';
import { FuncsService } from '../services/funcs.service';
import { DealerService } from '../services/dealer.service';
import { FordService } from '../services/ford.service';
import { Subscription } from '../data/subscription';
import { Customer, CustomerCurrent } from '../data/customer';
import { AccountInfoService } from '../services/account.service';
import { Country } from '../data/country';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver-es';

@Component({
  selector: 'app-fleet-status',
  templateUrl: './fleet-status.component.html',
  styleUrl: './fleet-status.component.css',
  standalone: false
})
export class FleetStatusComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['pa_code', 'name', 'country', 'tech_count', 'subscribed', 'actions'];

  public loading = "Loading...";
  countries: string[] = [];
  countriesList: Country[] = [];
  searchCtrl = new FormControl('');
  filteredCountries: Observable<Country[]> = of([]);
  country: string | null = "USA";

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  dealers = DEALER_STATUSES;
  displayedDealers = this.dealers;
  search = "";
  enrolled = "E";
  queryEnrolled: string = "";
  subscribedFlags: any[] = [];
  subscribed = "all";
  dealersNotInAPI: string[] = [];
  tempRole: any = "";
  searchText: string = '';

  dataSource = new MatTableDataSource<DealerStatus>(this.displayedDealers);

  constructor(
    private dealerService: DealerService,
    private router: Router,
    private route: ActivatedRoute,
    private fordService: FordService,
    private funcs: FuncsService,
    private accountInfoService: AccountInfoService
  ) { }

  ngOnInit() {
    this.funcs.checkAdmin();
    this.funcs.currentCustomer(CustomerCurrent);
    this.loading = "Loading...";

    this.tempRole = "not";

    this.subscribedFlags.push(
      { field: "all", value: "All" },
      { field: "Y", value: "Yes" },
      { field: "N", value: "No" }
    );

    this.getCountries(this.tempRole);

    this.getAllDealerStatus();
  }

  private filterCountries(value: string): Country[] {
    console.log('search:', value);
    const lowerCaseValue = value.toLowerCase();
    return this.countriesList
      .filter(c => this.countries.includes(c.countryCode3))
      .filter(country =>
        country.countryCode3.toLowerCase().includes(lowerCaseValue) ||
        country.countryName.toLowerCase().includes(lowerCaseValue)
      );
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getCountries(role: string) {
    this.accountInfoService.getCountries(role).subscribe(countries => {
      countries.forEach(ct => {
        this.countriesList.push({ countryName: ct.countryName, countryCode: ct.countryCode, countryCode3: ct.countryCode3, retailRestricted: ct.retailRestricted });
      });

      this.filteredCountries = this.searchCtrl.valueChanges.pipe(
        startWith(''),
        map(value => this.filterCountries(value ?? ''))
      );

    });
  }

  getAllDealerStatus(): void {

    function hasCountry(siteCode: string) {
      if (siteCode.length < 4) {
        return false;
      }
      var reCountryPrefix = /^[A-z]{3}/i;
      if (!reCountryPrefix.test(siteCode)) {
        return false;
      }
      return true;
    }

    const dealerStatusData = this.dealerService.getFleetStatus(CustomerCurrent.username);
    const subscriptionData = this.fordService.getAllSubscriptions();
    // var updateCount = 0;

    forkJoin([dealerStatusData, subscriptionData]).subscribe(responses => {
      this.dealers = responses[0].filter(s => hasCountry(s.pa_code));
      var subscriptions = responses[1].filter(s => hasCountry(s.siteCode));

      this.loading = "";

      subscriptions.forEach(s => {
        var changed = false;
        var subscribeDealer: DealerStatus = <DealerStatus>{};
        var iDealer = this.dealers.findIndex(d => d.pa_code === s.siteCode);
        // var currentMaxLogins = s.maxAllowedUniqueDealerTechnicianLogins;
        // var currentSessions = s.concurrentSessions;

        if (iDealer >= 0) {
          subscribeDealer = this.dealers.find(d => d.pa_code === s.siteCode) || <DealerStatus>{};
          subscribeDealer.tech_count = s.maxAllowedUniqueDealerTechnicianLogins;

          // set subscribed
          this.dealers[iDealer].subscribed = (this.funcs.isSubscribed(s)) ? "Y" : "- -";
        }
      });

      this.dealers.forEach(d => {
        var dealerSubscription: Subscription = <Subscription>{};
        if (this.countries.indexOf(d.country) === -1) {
          this.countries.push(d.country);

          this.filteredCountries = this.searchCtrl.valueChanges.pipe(
            startWith(''),
            map(value => this.filterCountries(value ?? ''))
          );
        }
        // collect new dealers here for insertion
        // USA and CAN ONLY!
        if (!d.subscribed && (d.country == "USA" || d.country == "CAN")) {
          /*if (singleUpdateFlag) {
            console.log(d.pa_code);
            singleUpdateFlag = false;

            // create new subscription
            await this.enrollNew(d.pa_code, d.tech_count);
            d.subscribed = "Y";
          }*/
        } else {
          // if international and enrolled, show tech count
          //show subscription numbers from FDSP
          dealerSubscription = subscriptions.find(s => d.pa_code === s.siteCode) || <Subscription>{};
          if (dealerSubscription.maxAllowedUniqueDealerTechnicianLogins) {
            d.tech_count = dealerSubscription.maxAllowedUniqueDealerTechnicianLogins;
          }
        }
      });

      this.countries = this.countries.sort();
      this.displayDealers();
    });
  }

  requiresTechCountUpdate(s: Subscription, tech_count: number) {
    var siteCountry = this.funcs.getThreeLetterCountry(s.siteCode);
    if (siteCountry != 'USA' && siteCountry != 'CAN') {
      return false;
    }
    if (!this.funcs.isSubscribed(s)) {
      return false;
    }

    // also make sure that concurrent = 5
    // and maxAllowedUniqueDealerTechnicianLogins is tech count + 5
    //return (s.concurrentSessions != 5 || s.maxAllowedUniqueDealerTechnicianLogins != tech_count + 5);
    return (s.concurrentSessions != 5 || s.maxAllowedUniqueDealerTechnicianLogins != tech_count);
  }

  displayDealers() {
    this.displayedDealers = this.dealers.filter(d => this.isDealer(d));
    this.dataSource.data = this.displayedDealers;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  applyFilter(event: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.searchText = filterValue;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  clearSearch() {
    this.searchText = '';
    this.applyFilter({ target: { value: '' } });
  }

  private isDealer = (d: DealerStatus, all?: boolean) => {
    var ciSearch = this.search.toLowerCase();
    var ciName = d.name.toLowerCase();
    if (this.dealersNotInAPI.indexOf(d.pa_code) > -1) {
      return false;
    }
    // Should a blank country be USA by default or just clean up the test data?
    return (d.pa_code.indexOf(ciSearch) > -1 || ciName.indexOf(ciSearch) > -1)
      && this.isEnrolled(d)
      && (all || this.subscribed == "all" ? d.subscribed === undefined || d.subscribed === "- -" || d.subscribed === "Y" :
        this.subscribed === "N" ? d.subscribed === undefined || d.subscribed === "- -" : d.subscribed === this.subscribed)
      && (all || d.country === this.country);
  };

  private isEnrolled = (d: DealerStatus) => {
    return true;
    /*if (this.enrolled === "E" && d.subscribed === "Y") {
      return true;
    }
    if (this.enrolled === "U" && d.subscribed === "N") {
      return true;
    }
    if (this.enrolled === "A") {
      return true;
    }
    return false;*/
  };

  fly(d: DealerStatus) {
    DealerCurrent.pa_code = d.pa_code;
    DealerCurrent.name = d.name;
    DealerCurrent.tech_count = d.tech_count;
    DealerCurrent.subscribed = d.subscribed;
    DealerCurrent.active = "";

    // persist data
    var dealerStore = {
      pa_code: DealerCurrent.pa_code,
      name: DealerCurrent.name,
      tech_count: DealerCurrent.tech_count,
      subscribed: DealerCurrent.subscribed,
      active: DealerCurrent.active
    };
    window.localStorage.setItem("dealer", JSON.stringify(dealerStore));
    this.router.navigate(['/status-enrolled'], {
      queryParams: { ref: 'fleet' },
    });
  };

  codeOnly(pa_code: string): string {
    if (pa_code.length <= 3) {
      return pa_code;
    }
    return pa_code.slice(3);
  }

  // download(all?: boolean) {
  //   var now = new Date();
  //   var c = all ? "" : this.country;
  //   var csv = ["Site Code, Name, Country, FIN Code, Subscriptions"];
  //   this.dealers.filter(d => this.isDealer(d, all)).forEach(d => {
  //     csv.push(`"${d.pa_code}","${d.name}","${d.country}","${this.codeOnly(d.pa_code)}",${d.tech_count || 0}`);
  //   });
  //   var data = new Blob([csv.join("\n")]);
  //   var a: HTMLAnchorElement = document.createElement("a");
  //   a.download = `Fleet FDSP Subscription Report ${c} ${now.toISOString().split('T')[0]}.csv`;
  //   a.href = URL.createObjectURL(data);
  //   a.click();
  // }

  exportToExcel(all?: boolean) {
    // const data = this.dataSource.data.map(row => ({ ...row }));
    const data = this.dealers.filter(d => this.isDealer(d, all));

    const headers: string[] = ['Site Code', 'Subscriptions', 'Name', 'Country', 'Enrolled'];

    const hiddenColumns = ['startDate', 'expiresAt', 'concurrent_sessions'];

    const exportData = data.map(row => {
      const filtered: { [key: string]: any } = {};
      Object.keys(row).forEach(key => {
        if (!hiddenColumns.includes(key)) {
          filtered[key] = row[key as keyof DealerStatus];
        }
      });
      return filtered;
    });

    const ws = XLSX.utils.json_to_sheet([], { header: headers });
    XLSX.utils.sheet_add_json(ws, exportData, { skipHeader: true, origin: 'A2' });

    // const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    var now = new Date();
    var c = all ? "" : this.country;

    // Detect date fields automatically
    const dateColumns: number[] = [];
    const headerColumns = headers;

    headerColumns.filter((res, index) => {
      if (res === "Start Date" || res === "Expires At") {
        dateColumns.push(index);
      }
    })

    // Apply date formatting to detected date columns
    const range = XLSX.utils.decode_range(ws['!ref']!);

    dateColumns.forEach(colIndex => {
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        const cellRef = XLSX.utils.encode_cell({ r: row, c: colIndex });
        const cell = ws[cellRef];

        if (cell && cell.v) {
          cell.t = 'd';                 // mark as date
          cell.z = 'mm/dd/yyyy';        // Excel date format
          cell.v = new Date(cell.v);    // ensure proper date object
        }
      }
    });

    // Create workbook
    const wb: XLSX.WorkBook = {
      Sheets: { Data: ws },
      SheetNames: ['Data']
    };

    // Write file
    const excelBuffer = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true
    });

    saveAs(
      new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      `Fleet FDSP Subscription Report - ${c} ${now.toISOString().split('T')[0]}.xlsx`
    );
  }
}
